import styled from '@emotion/styled'
import Link from 'components/Link'

const GateForContentConfirmationLink = styled(Link)`

`

export default GateForContentConfirmationLink